import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  Grid,
  FormControl,
  TextField,
  CircularProgress,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Tooltip,
  Fab, 
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Add } from '@material-ui/icons';
import {
  validarTeclascomunes,
  limpiarValorMondeda,
  convertirAMoneda,
  validarSoloNumeros,
} from 'utils/utils'
import { isAlphanumeric } from 'validator'
import useStyles from './formulario.styles'
import FormularioPrestador from '../FormularioPrestador';

function Formulario({
  onSubmit,
  onChange,
  prestador,
  alfa,
  numeroFactura,
  pbs,
  valor,
  valorConMascara,
  archivos,
  loading,
  limpiarFormulario,
  mostrarMensajeError,
  cantidadMaximaDeArchivos,
  esCargaMasiva,
  prestadores,
  obtenerPrestadores
}) {
  const classes = useStyles()
  const [abrir, setAbrir] = useState(false);
  const validarFormulario = async (e) => {
    onChange({ target: { name: 'mensajeAlerta', value: '' } })
    e.preventDefault()
    if (!esCargaMasiva) {
      if (!prestador.nit) {
        mostrarMensajeError('El campo NIT es obligatorio.')
        window.scrollTo(0, 0)
        return
      }
      if (prestador.nit.length < 4) {
        mostrarMensajeError('El campo NIT debe contener mínimo 4 digitos.')
        window.scrollTo(0, 0)
        return
      }

      if (!validarSoloNumeros(prestador.nit)) {
        mostrarMensajeError('El campo NIT debe ser numérico.')
        window.scrollTo(0, 0)
        return
      }

      if (alfa && !isAlphanumeric(alfa)) {
        mostrarMensajeError('El campo Alfa debe ser alfanumérico.')
        window.scrollTo(0, 0)
        return
      }

      if (!numeroFactura) {
        mostrarMensajeError('El campo Número de factura es obligatorio.')
        window.scrollTo(0, 0)
        return
      }

      if (!validarSoloNumeros(numeroFactura)) {
        mostrarMensajeError('El campo Número de factura debe ser numérico.')
        window.scrollTo(0, 0)
        return
      }

      if (!valor) {
        mostrarMensajeError('El campo Valor Neto es obligatorio.')
        window.scrollTo(0, 0)
        return
      }

      if (!pbs) {
        mostrarMensajeError('El campo BPS es obligatorio.')
        window.scrollTo(0, 0)
        return
      }
    }

    if (!archivos.length) {
      mostrarMensajeError('Debe cargar mínimo un archivo.')
      window.scrollTo(0, 0)
      return
    }

    if (!archivos.length) {
      mostrarMensajeError('Debe adjuntar las imágenes para realizar la carga.')
      window.scrollTo(0, 0)
      return
    }

    if (archivos.length > cantidadMaximaDeArchivos) {
      mostrarMensajeError(`Solo se permite cargar máximo ${cantidadMaximaDeArchivos} archivos.`)
      window.scrollTo(0, 0)
      return
    }
    onSubmit()
  }
  const cerrar = () => {
    setAbrir(false)
    obtenerPrestadores()
  }
  return (
    <form noValidate autoComplete='off' onSubmit={validarFormulario}>
      <Grid container justify='center'>
        {!esCargaMasiva && (
          <>
            <FormControl fullWidth>
              <Grid container>
                <Grid item xs={8} md={8} sm={12}>
                  <Autocomplete
                    disabled={loading}
                    id='nit'
                    name='nit'
                    options={prestadores}
                    getOptionLabel={(option) => option.nit ? `${option.nit} - ${option.nombre}` : ''}
                    style={{ width: '100%' }}
                    renderInput={(params) => <TextField {...params} label='NIT' />}
                    onChange={(event, prestador) => {
                      if (prestador) {
                        onChange({ target: { name: 'prestador', value: prestador } })
                      }
                    }}
                    value={prestador}
                  />
                </Grid>
                <Grid item xs={4} md={4} sm={12}>
                  <Tooltip title="Si no encuentras tú NIT, regístralo.">
                    <Button color="primary" variant="outlined" style={{ fontSize: 13, width: '95%', marginLeft: 10}} size="small" onClick={() => setAbrir(true)}>
                      Agregar prestador
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </FormControl>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                disabled={loading}
                name='alfa'
                label='Alfa'
                value={alfa}
                onChange={(e) => onChange({ target: { name: 'alfa', value: e.target.value.toUpperCase() } })}
                onKeyDown={(e) => {
                  if (validarTeclascomunes(e.key) && !isAlphanumeric(e.key)) e.preventDefault()
                }}
                inputProps={{
                  maxLength: 6,
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                required
                disabled={loading}
                name='numeroFactura'
                label='Número de factura'
                value={numeroFactura}
                onChange={onChange}
                onKeyDown={(e) => {
                  if (validarTeclascomunes(e.key) && !validarSoloNumeros(e.key)) e.preventDefault()
                }}
                inputProps={{
                  maxLength: 10,
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                required
                disabled={loading}
                name='valor'
                label='Valor Neto'
                value={valorConMascara}
                onChange={(e) => {
                  const valorFiltrado = limpiarValorMondeda(e.target.value)
                  if (valorFiltrado.length > 15) return
                  onChange({ target: { name: 'valor', value: Number(valorFiltrado) } })
                  onChange({
                    target: { name: 'valorConMascara', value: convertirAMoneda(valorFiltrado) },
                  })
                }}
                onKeyDown={(e) => {
                  if (validarTeclascomunes(e.key) && !validarSoloNumeros(e.key)) e.preventDefault()
                }}
                inputProps={{
                  maxLength: 21,
                }}
              />
            </FormControl>
            <FormControl className={classes.valor} component='fieldset'>
              <RadioGroup
                aria-label='gender'
                name='pbs'
                value={pbs}
                onChange={onChange}
                required
                disabled={loading}
              >
                <FormControlLabel value='PBS' control={<Radio color='primary' />} label='PBS' />
                <FormControlLabel value='NPBS' control={<Radio color='primary' />} label='NPBS' />
              </RadioGroup>
            </FormControl>
          </>
        )}
        <Grid container justify='center'>
          <FormControl>
            <Grid container direction='row'>
              <div className={classes.wrapper}>
                <Button
                  variant='outlined'
                  color='primary'
                  type='submit'
                  disabled={loading}
                  className={classes.btn}
                >
                  Aceptar
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
              <Grid item style={{ marginTop: 8 }}>
                <Button
                  variant='outlined'
                  color='secondary'
                  disabled={loading}
                  onClick={limpiarFormulario}
                >
                  Limpiar
                </Button>
              </Grid>
            </Grid>
          </FormControl>
        </Grid>
      </Grid>
      <FormularioPrestador open={abrir} cerrar={cerrar}/>
    </form>
  )
}

Formulario.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  prestador: PropTypes.object.isRequired,
  alfa: PropTypes.string.isRequired,
  numeroFactura: PropTypes.string.isRequired,
  valor: PropTypes.number.isRequired,
  valorConMascara: PropTypes.string.isRequired,
  archivos: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  limpiarFormulario: PropTypes.func.isRequired,
  mostrarMensajeError: PropTypes.func.isRequired,
  cantidadMaximaDeArchivos: PropTypes.number.isRequired,
  esCargaMasiva: PropTypes.bool.isRequired,
}

export default React.memo(Formulario)
